import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Sentry error tracking (production only)
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,

    // Capture 100% of transactions for performance monitoring
    tracesSampleRate: 0.1,

    // Don't send errors in development
    enabled: process.env.NODE_ENV === 'production',

    // Filter out common non-actionable errors
    ignoreErrors: [
      // Browser extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Network errors users can't control
      'Network request failed',
      'Failed to fetch',
      'Load failed',
      // ResizeObserver noise
      'ResizeObserver loop limit exceeded',
    ],

    // Scrub sensitive data
    beforeSend(event) {
      // Remove any email addresses from error messages
      if (event.message) {
        event.message = event.message.replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, '[EMAIL]');
      }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
